import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import {FormControl, Validators} from '@angular/forms';
import {ConfirmationDialogData} from '../../../../core/interfaces/confirmation-dialog-data';
import {ConfirmationDialogs, ConfirmationDialogsGetter} from './confirmation-dialogs.enum';

interface ModalData {
	mode: ConfirmationDialogs;
	account?: string;
	flags?: any;
	disableClose?: boolean;
	disableClick?: boolean;
}

@Component({
  selector: 'app-confirm-navigation',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent implements OnInit {

	confirmationFormControl: FormControl<string>;
	accountName: string;
	ipAddress: string;
	customerName: string;
	showWarningMessage = true;

	populatedData: ConfirmationDialogData;
	
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: ModalData,
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    private translateService: TranslateService
	) { }

  ngOnInit() {
		this.dialogRef.disableClose = this.data.disableClose || false;
		if (this.data.disableClick) {
			this.dialogRef.disableClose = true;
			this.dialogRef.backdropClick().subscribe($event => {});
		}
	  this.populatedData = ConfirmationDialogsGetter.getDialogData(this.data.mode, this.data.flags);
	  console.log('Function: ngOnInit, this.populatedData: ', this.populatedData);

	  if (this.populatedData.passKey) {
		  this.confirmationFormControl = new FormControl('', [
			  Validators.required,
			  Validators.pattern(new RegExp('^' + this.translateService.instant(this.populatedData.passKey) + '$', 'i')),
		  ]);
	  }
	  if (this.data.account !== '') {
	  	this.accountName = this.data.account;
	  }
  }

	onKeypress(event) {
		if (event.keyCode === 13) {
		  if (this.confirmationFormControl && this.confirmationFormControl.dirty && this.confirmationFormControl.valid) {
			  this.dialogRef.close(true);
      }
		}
	}

	onClose(event){
		event.stopPropagation();
		this.dialogRef.close();
	}

	onRemoval(event){
		event.stopPropagation();
		this.dialogRef.close(true);
	}

}
